import { useState, useRef } from 'react';
import { motion, useMotionValue, PanInfo } from 'framer-motion';
import { Spot } from '@/types/spots';
import SpotLargeCard from './SpotLargeCard';

interface BottomSheetProps {
  spots: Spot[];
  selectedSpot: Spot | null;
  onSelectSpot: (spot: Spot) => void;
}

const BottomSheet = ({ spots, selectedSpot, onSelectSpot }: BottomSheetProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const constraintsRef = useRef(null);
  const y = useMotionValue(0);
  
  // Snap points
  const collapsedY = 0;
  const expandedY = -400;

  const handleDragEnd = (_: any, info: PanInfo) => {
    const shouldExpand = info.velocity.y < -200 || info.offset.y < -100;
    setIsExpanded(shouldExpand);
  };

  return (
    <motion.div
      ref={constraintsRef}
      className="fixed bottom-0 left-0 right-0 z-30"
      initial={{ y: collapsedY }}
      animate={{ y: isExpanded ? expandedY : collapsedY }}
      transition={{ type: 'spring', damping: 30, stiffness: 300 }}
    >
      <motion.div
        drag="y"
        dragConstraints={{ top: expandedY, bottom: collapsedY }}
        dragElastic={0.1}
        onDragEnd={handleDragEnd}
        style={{ y }}
        className="bg-background rounded-t-3xl shadow-[0_-4px_20px_rgba(0,0,0,0.1)] min-h-[85vh]"
      >
        {/* Drag handle */}
        <div className="flex justify-center pt-3 pb-4 cursor-grab active:cursor-grabbing">
          <div className="w-10 h-1 bg-muted-foreground/30 rounded-full" />
        </div>

        {/* Header */}
        <div className="px-4 pb-4">
          <p className="text-center text-muted-foreground font-medium">
            {spots.length} Spaces on Monday
          </p>
        </div>

        {/* Cards list */}
        <div className="px-4 pb-8 space-y-4 overflow-y-auto max-h-[70vh]">
          {spots.map((spot) => (
            <SpotLargeCard
              key={spot.id}
              spot={spot}
              isSelected={selectedSpot?.id === spot.id}
              onSelect={onSelectSpot}
            />
          ))}
        </div>
      </motion.div>
    </motion.div>
  );
};

export default BottomSheet;
